import { observer } from 'mobx-react';
import React from 'react';
import { Footer } from 'telia-front-react';
import mapFooterColumns, { getDigitarkLogoProps, getTeliaLogoProps, mapFooterBottomLinks, mapFooterSocialMediaItems } from './FooterColumns';
import { DIGITARK_IDS } from './store/FooterColumnStore';
const FooterContainer = (props) => {
    const { translate } = props.rootStore.translationsStore;
    const footerColumns = mapFooterColumns(props.rootStore);
    const socialMediaItems = mapFooterSocialMediaItems(props.rootStore);
    const bottomLinks = mapFooterBottomLinks(props.rootStore);
    const digitarkLogoProps = getDigitarkLogoProps(socialMediaItems.find((item) => DIGITARK_IDS.includes(item.id)));
    const footerFooter = [
        {
            content: translate('footer.companyLabel')
        },
        {
            content: translate('footer.companyTrademarkLabel')
        }
    ];
    return (React.createElement(Footer, { footer: footerFooter, columns: footerColumns, socialMediaItems: socialMediaItems.filter((item) => !DIGITARK_IDS.includes(item.id)), bottomLinks: bottomLinks, digitalHubLogo: digitarkLogoProps, logo: getTeliaLogoProps(props.rootStore) }));
};
export default observer(FooterContainer);
//# sourceMappingURL=FooterContainer.js.map